<template>
  <div class="site-wrapper">
    <transition-group name="loader-fade">
      <g-site-loader v-if="isLoading" :key="1">Loading...</g-site-loader>
      <Header :key="2" />
      <main :key="3">
        <transition name="fade" mode="out-in" @before-enter="beforeEnter">
          <router-view />
        </transition>
      </main>
      <Footer :key="4" />
    </transition-group>
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue';
import Header from '@/components/Header.vue';
export default {
  components: {
    Footer,
    Header
  },
  data: function() {
    return {
      isLoading: false
    };
  },
  created() {
    this.$apollo.provider.watchLoading = (isLoading, countModifier) => {
      this.isLoading = isLoading;
    };
  },
  methods: {
    beforeEnter() {
      this.$root.$emit('scrollBeforeEnter');
    }
  }
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.loader-fade-enter-active,
.loader-fade-leave-active {
  transition: opacity 0.3s;
  transition-delay: 0.25s;
}

.loader-fade-enter,
.loader-fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
